var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.844821 5.24219C0.490269 5.24219 0.283384 4.84212 0.488321 4.55279L3.35693 0.502996C3.53104 0.257193 3.89582 0.257193 4.06993 0.502996L6.93853 4.55279C7.14347 4.84212 6.93658 5.24219 6.58203 5.24219H0.844821Z",
    fill: "#2D2C2C",
    stroke: "#236DFF",
    strokeWidth: 0.262124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58096 7.86719C6.93551 7.86719 7.1424 8.26726 6.93746 8.55658L4.06885 12.6064C3.89474 12.8522 3.52997 12.8522 3.35585 12.6064L0.487248 8.55658C0.282311 8.26726 0.489196 7.86719 0.843748 7.86719H6.58096Z",
    fill: "#236DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDown);
export default __webpack_public_path__ + "static/media/filterDown.fc43d64320b62b373a9943d19435f25c.svg";
export { ForwardRef as ReactComponent };